module.exports = __webpack_public_path__ + "static/media/DSC02603.d8671e41.jpg";